import { Box, Modal, Typography, Button, Stack } from "@mui/material";
import "./address.css";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import classes from "./address.module.css";
import { Numeric } from "../../../utilities/commonFunctions";
import { useEffect } from "react";
import { MdClose } from "react-icons/md";
import { useSelector } from "react-redux";

function AddAddressPop(props) {
  const {
    open,
    handleClose,
    inputs,
    handleInputs,
    setIsMapScreen,
    handleAddAddress,
    singleAddress,
    handleUpdateAddress,
  } = props;

  const { addSuccess, addFailure } = useSelector(
    (state) => state.address
  );

  useEffect(() => {
    // Adding custom validation rule for phone number length
    ValidatorForm.addValidationRule("isTenDigits", (value) => {
      if (value && value?.length !== 10) {
        return false;
      }
      return true;
    });

    // Clean up the rule on unmount
    return () => ValidatorForm.removeValidationRule("isTenDigits");
  }, []);

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        container={() => document.body}
      >
        <Box
          className={classes.loginModalWidth}
          sx={{
            bgcolor: "background.paper",
            boxShadow: 24,
            width: "480px",
            maxHeight: "90vh",
            overflowY: "auto",
          }}
        >
          <Box className={classes.AddMemberHeading}>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              {singleAddress ? "Edit" : "Add"} Customer
            </Typography>
          </Box>
          <Button
            variant="text"
            sx={{ minWidth: "unset" }}
            className={classes.closebtn}
            onClick={handleClose}
          >
            <MdClose />
          </Button>
          <Box p={3} pt={1}>
            <ValidatorForm
              useref="form"
              onSubmit={singleAddress ? handleUpdateAddress : handleAddAddress}
              className={classes.SignUpForm}
            >
              <Box mb={2}>
                <Typography className={`${classes.form_lable}`} sx={{ mb: 1, display: 'block' }}>
                  Name*
                </Typography>
                <TextValidator
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                  id="emailInput"
                  placeholder="eg: arun"
                  className={`${classes.formInputFeild} my-field`}
                  name="name"
                  value={inputs.name}
                  size="small"
                  onChange={handleInputs}
                  validators={["required"]}
                  errorMessages={["Name is required"]}
                />
              </Box>
              <Box mb={2}>
                <Typography className={`${classes.form_lable}`} sx={{ mb: 1, display: 'block' }}>
                  Mobile Number (optional)
                </Typography>
                <TextValidator
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                  id="phoneInput"
                  placeholder="eg: 8615222330"
                  className={`${classes.formInputFeild} my-field`}
                  name="phone"
                  value={inputs.phone}
                  size="small"
                  onChange={handleInputs}
                  onKeyPress={(e) => {
                    Numeric(e);
                  }}
                  validators={["isTenDigits"]}
                  errorMessages={["Mobile number must be exactly 10 digits"]}
                />
              </Box>
              <Box mb={2}>
                <Typography className={`${classes.form_lable}`} sx={{ mb: 1, display: 'block' }}>
                  Address (optional)
                </Typography>
                <TextValidator
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  variant="outlined"
                  autoComplete="off"
                  fullWidth
                  id="emailInput"
                  placeholder="eg: 123 street"
                  className={`${classes.formInputFeild} my-field`}
                  name="address"
                  value={inputs.address}
                  size="small"
                  onChange={handleInputs}
                />
              </Box>
              <Box mb={2}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{ mb: 1 }}
                >
                  <Typography className={`${classes.form_lable}`}>
                    Google Map Location*
                  </Typography>
                  <Typography
                    onClick={() => setIsMapScreen(true)}
                    sx={{ cursor: 'pointer', color: '#227dc3', fontSize: '14px', fontWeight: 600 }}
                  >
                    Add from Map
                  </Typography>
                </Box>

                <TextValidator
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  variant="outlined"
                  multiline
                  rows={2}
                  autoComplete="off"
                  fullWidth
                  id="emailInput"
                  placeholder="Paste google map link here or click 'Add from Map'"
                  className={`${classes.formInputFeild}`}
                  name="maplink"
                  value={inputs.maplink}
                  size="small"
                  onChange={handleInputs}
                  validators={["required"]}
                  errorMessages={["Google map link required"]}
                />
              </Box>
              <Stack direction="row" spacing={2} sx={{ mt: 4, justifyContent: 'flex-end' }}>
                <Button variant="outlined" onClick={handleClose} sx={{ minWidth: "120px", borderRadius: "8px", textTransform: "capitalize" }}>
                  Cancel
                </Button>
                <Button 
                    variant="contained" 
                    type="submit" 
                    sx={{ minWidth: "120px", borderRadius: "8px", textTransform: "capitalize" }}
                >
                  {singleAddress ? "Update" : "Add"} Customer
                </Button>
              </Stack>
              {addSuccess && (
                <Typography className={classes.success_text}>
                  Successfully {singleAddress ? "Updated" : "Added"}{" "}
                </Typography>
              )}
              {addFailure && (
                <Typography className={classes.failure_text}>
                  Try Again later{" "}
                </Typography>
              )}
            </ValidatorForm>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default AddAddressPop;
